import React, { useEffect, useState, useRef } from "react";
import { RoundedSubmitButton, ButtonText } from "BaseComponents/Button";
import { RoundedInput, RoundInputWrapper } from "BaseComponents/Form";
import { SearchFieldWrapper, SearchFieldInnerWrapper } from "./StyledSearchFieldComponents";
import { useSelector } from "react-redux";
import { useMeasure } from "react-use";
import { useSpring, useChain, useTransition, animated, config } from "react-spring";
import { HtmlDecode } from "Helpers/TextHelper";
import { HandleClick } from "Helpers/LinkHelper";
import { useGlobal } from "reactn";

export const SearchField = () => {
	const defaultHeight = "0px";
	const state = useSelector(({ searchField }) => searchField);
	const [show, toggle] = useState(false);
	const [searchUrl, setSearchUrl] = useState(state.url);
	const [searchText, setSearchText] = useState(state.text);
	const [ref, { height }] = useMeasure();
	const [contentHeight, setContentHeight] = useState(defaultHeight);
	const inputEl = useRef(null);
	const springRef = useRef();
	const transRef = useRef();
	const [showClass, setShowClass] = useState(false);
	const [theme] = useGlobal("theme");

	const expand = useSpring({
		ref: springRef,
		config: config.stiff,
		height: show ? `${contentHeight}px` : defaultHeight,
	});

	const data = [
		{
			name: "inputContent",
			id: 2093845,
		},
	];

	const transition = useTransition(show ? data : [], (item) => item.name, {
		ref: transRef,
		unique: true,
		trail: 400 / data.length,
		from: {
			opacity: 0,
			width: "100%",
			transform: "translateY(-2rem)",
		},
		enter: {
			opacity: 1,
			width: "100%",
			transform: "translateY(0rem)",
		},
		leave: {
			opacity: 0,
			width: "100%",
			transform: "translateY(-2rem)",
		},
	});

	useEffect(() => {
		toggle(state.show);
		setSearchUrl(state.url);
		setSearchText(HtmlDecode(state.text));
	}, [state]);

	useEffect(() => {
		if (show) {
			inputEl.current.focus();

			const timer = setTimeout(() => {
				setShowClass(true);
			}, 1000);
			return () => clearTimeout(timer);
		} else {
			setShowClass(false);
		}
	}, [show]);

	useChain([transRef, springRef], [0, show ? 0.3 : 0.1]);

	useEffect(() => {
		setContentHeight(height);

		window.addEventListener("resize", setContentHeight(height));

		return window.removeEventListener("resize", setContentHeight(height));
	}, [height]);

	const OnSearch = (e) => {
		e.preventDefault();
		let query = inputEl.current.value;

		if (query.length) {
			HandleClick(e, `${searchUrl}?query=${query}`);
		}
	};

	const OnKeyDown = (e) => {
		if (e.key === "Enter") {
			OnSearch(e);
		}
	};

	return (
		<animated.div style={expand}>
			<SearchFieldWrapper
				backgroundImage={theme.colors.lightgrey}
				justifyContent="center"
				ref={ref}
				className={showClass ? "open" : ""}
			>
				{transition.map(({ item, key, props }) => (
					<animated.div style={props} key={`search-field-item-${key}`}>
						<SearchFieldInnerWrapper
							smallAlignContent="center"
							alignItems="center"
							justifyContent="center"
							padding="1rem"
							max-width="615px"
							minheight="100%"
						>
							<RoundInputWrapper maxwidth="615px;">
								<RoundedInput
									ref={inputEl}
									padding="0 0 0 1rem"
									placeholder={searchText}
									border="1px solid #8f8f8f"
									onKeyDown={(e) => OnKeyDown(e)}
								/>
								<RoundedSubmitButton hoverBorder="1px solid #8f8f8f">
									<ButtonText
										forcedFontSize="24px"
										forcedFontSizeSmall="16px"
										onClick={(e) => OnSearch(e)}
										aria-label={searchText}
										heading={`button ${searchText}`}
									>
										{searchText}
									</ButtonText>
								</RoundedSubmitButton>
							</RoundInputWrapper>
						</SearchFieldInnerWrapper>
					</animated.div>
				))}
			</SearchFieldWrapper>
		</animated.div>
	);
};
